module.exports = __webpack_public_path__ + "media/site_templates/www.localhousepainters.com.au/images/feature_3-b12bcb4086d9f12d1897914b77d17b6b.jpeg";